import { TFunction } from 'i18next';
import { QuestionType } from '../../../enum/QuestionType';
import { FormQuestion } from '../../../models/FormQuestion';
import { RequirementResult } from '../../../models/RequirementResults';
import { FormService } from '../../../services/FormService';

export class FormResultReplaceHTMLTagsService {
  constructor(
    private formService: FormService,
    private readonly t: TFunction,
  ) {}

  public replaceTags(
    html: string,
    questions: FormQuestion[],
    values: Record<string, any>,
    results: RequirementResult[]
  ): string {
    let html2render = html;

    html2render = this._replaceQuestions(html2render, questions, values);
    html2render = this._replaceValues(html2render, questions, values);
    html2render = this._replaceRequirements(html2render, results);
    html2render = this._cleanRemainingTags(html2render);

    return html2render;
  }

  //region REPLACE


  private _replaceQuestions(
    html: string,
    questions: FormQuestion[],
    values: Record<string, any>
  ): string {
    for (const qst of questions) {
      const replace = `{{question.${ qst.question }}}`;
      const re = new RegExp(replace, 'g');

      const translation = (qst.question in values)
        ? this.formService.t(this.t, qst.question, false)
        : '';

      html.replace(re, translation);
    }

    return html;
  }

  private _replaceValues(
    html: string,
    questions: FormQuestion[],
    values: Record<string, any>
  ): string {

    for (const [key, value] of Object.entries(values)) {
      const replace = `{{value.${ key }}}`;
      const re = new RegExp(replace, 'g');

      if (typeof value === 'object') {
        let question: any = null;
        let tableHeader = '';

        questions.forEach((q) => {
          if (q.question === key) {
            question = q;
          }
        });

        if (question.subQuestions) {
          for (const subQ of question.subQuestions) {
            tableHeader += `<td>${ this.formService.t(this.t, subQ.question, false) }</td>`;
          }
        }

        let table: any = null;
        table = `<table>
                    <thead>
                        <tr>${ tableHeader }</tr>
                    </thead>
                    <tbody>
                        ${ this._getTableBody(question, value, values) }
                    </tbody>
                  </table>`;

        html = html.replace(re, table);
      }
      else {
        switch (value) {
          case true:
            html = html.replace(re, this.formService.t(this.t, "oui", false));
            break;
          case false:
            html = html.replace(re, this.formService.t(this.t, "non", false));
            break;
          default:
            html = html.replace(re, this.formService.t(this.t, value, false));
            break;
        }
      }
    }
    return html;
  }

  private _replaceRequirements(
    html: string,
    results: RequirementResult[],
  ): string {

    for (const result of results) {
      const { requirement, requirementTitle, answer } = result;

      const replaceAnswer = `{{requirement.answer.${requirement}}}`;
      const replaceRequirement = `{{requirement.requirement.${requirement}}}`;
      const replaceRequirementTitle = `{{requirement.title.${requirement}}}`;

      if (answer && typeof answer === 'object') {
        if (Array.isArray(answer)) {
          let multipleAnswerHTML = '';

          for (const ans of answer) {
            multipleAnswerHTML += this.formService.t(this.t, ans, false, false, true);
          }

          const re = new RegExp(replaceAnswer, 'g');
          html = html.replace(re, multipleAnswerHTML);
        }
        else {
          const regexForProperties = new RegExp(`{{requirement.answer.${requirement}.(.+?)}}`, 'g');

          // Parcourir l'objet et remplacer les propriétés dynamiques
          html = html
            .replace(
              regexForProperties,
              (_, propertyPath) => {
                const nestedValue = this._getNestedProperty(answer, propertyPath);

                return nestedValue !== undefined
                  ? nestedValue
                  : `{{requirement.answer.${requirement}.${propertyPath}}}`;
              });
        }
      }

      else if (typeof answer === 'string' && answer.includes('{{translation.')) {
        let answerForTranslation = answer as any;
        let result: any = null;
        const regex = new RegExp(/[{]{2}translation[.](.+?)[}]{2}/g);

        for (let j = 0; j < 25; j++) {
          while (null !== (result = regex.exec(answerForTranslation))) {
            answerForTranslation = answerForTranslation
              .replace(
                `{{translation.${ result[1] }}}`,
                this.formService.t(this.t, result[1], false, false, true)
              );
          }
        }

        html = html.replace(replaceAnswer, answerForTranslation);
      }
      else {
        html = this._replaceHtml(replaceAnswer, answer, html);
      }

      html = this._replaceHtml(replaceRequirement, requirement, html);
      html = this._replaceHtml(replaceRequirementTitle, requirementTitle, html);
    }

    let result: any = null;
    const regex = new RegExp(/[{]{2}translation[.](.+?)[}]{2}/g);

    while (null !== (result = regex.exec(html))) {
      html = html
        .replace(
          `{{translation.${ result[1] }}}`,
          this.formService.t(this.t, result[1], true, false, true)
        );
    }

    let resultImage: any = null;
    const regexImage = new RegExp(/[{]{2}image[.](.+?)[}]{2}/g);

    while (null !== (resultImage = regexImage.exec(html))) {
      html = html
        .replace(
          `{{image.${ resultImage[1] }}}`,
          this.formService.t(
            this.t,
            resultImage[1],
            false,
            false,
            false,
            true
          )
        );
    }
    return html;
  }

  private _cleanRemainingTags(html: string,): string {
    const replace = `{{value.*?}}`;
    const re = new RegExp(replace, 'g');
    html  = html .replace(re, '');

    const replace2 = `{{question.*?}}`;
    const re2 = new RegExp(replace2, 'g');
    html  = html .replace(re2, '');

    const replace3 = `{{requirement.*?}}`;
    const re3 = new RegExp(replace3, 'g');
    html  = html .replace(re3, '');

    const replace4 = `{{image.*?}}`;
    const re4 = new RegExp(replace4, 'g');
    html  = html .replace(re4, '');

    let resultTitle: any = null;
    const regexTitle = new RegExp(/(<[hH]\d.*?>)([^<]+?)(<\/[hH]\d.*?>)/, 'g');

    while (null !== (resultTitle = regexTitle.exec(html ))) {
      html  = html
        .replace(
          resultTitle[0],
          `${ resultTitle[1] }${ resultTitle[2].replace(/ /g, '&nbsp;') }${ resultTitle[3] }`
        );
    }

    const fakeHTMLElement = document.createElement("div")

    fakeHTMLElement.innerHTML = html ;
    const aElements = fakeHTMLElement.getElementsByTagName("a")

    for (let i = 0; i < aElements.length; i++) {
      aElements[i].setAttribute("target", "_blank")
    }

    html  = fakeHTMLElement.innerHTML;

    return html;
  }



  //endregion

  //region UTILS

  private _getTableBody(
    question: FormQuestion,
    value: any,
    values: Record<string, any>
  ): string {
    let tableBody = '';
    for (let i = 0; i < value.length; i++) {
      tableBody += `
        <tr>${ 
          this._getTableRow(question, value[i], i, values) 
        } </tr>`;
    }
    return tableBody;
  }

  private _getTableRow(
    question: FormQuestion,
    el: any,
    i: number,
    values: Record<string, any>
  ): string {
    let row = '';
    if (question.subQuestions) {
      for (const subQ of question.subQuestions) {
        if (subQ.type === QuestionType.PREVIOUS_QUESTION && values[subQ.target][i]) {
          row += `<td>${ values[subQ.target][i][subQ.question] }</td>`;
        }
        else {
          row += `<td>${ this.formService.t(this.t, el[subQ.question], false) }</td>`;
        }
      }
    }
    return row;
  }

  private _getNestedProperty(obj: any, propertyPath: string) {
    return propertyPath.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  private _replaceHtml(replaceElement: string, value: string, html) {
    const re = new RegExp(replaceElement, 'g');
    return html.replace(re, this.formService.t(this.t, value, true, false, true));
  }

  //endregion



}